"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFeedbackBenefitDialog = exports.defaultFeedbackBenefitDialogContextValue = exports.Provider = exports.FeedbackBenefitDialogProvider = void 0;
var _openFeedbackBenefitDialog = require("@ori-events/open-feedback-benefit-dialog");
var _presentationHooks = require("@ori/presentation-hooks");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _constants = require("../constants");
var _net = require("../models/graphql-types/net");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore next @preserve -- no need to test default function
const defaultOnClose = () => {};
const defaultFeedbackBenefitDialogContextValue = exports.defaultFeedbackBenefitDialogContextValue = {
  cataloguePageNumber: undefined,
  catalogueId: undefined,
  favoriteListId: undefined,
  open: false,
  productCode: undefined,
  type: undefined,
  onClose: defaultOnClose
};
const feedbackBenefitDialogContext = /*#__PURE__*/(0, _react.createContext)(defaultFeedbackBenefitDialogContextValue);
const {
  Provider
} = feedbackBenefitDialogContext;
exports.Provider = Provider;
const FeedbackBenefitDialogProvider = ({
  open,
  children,
  onClose: onCloseParam,
  onOpen: onOpenParam
}) => {
  const [type, setType] = (0, _react.useState)(undefined);
  const [productCode, setProductCode] = (0, _react.useState)(undefined);
  const [cataloguePageNumber, setCataloguePageNumber] = (0, _react.useState)(undefined);
  const [catalogueId, setCatalogueId] = (0, _react.useState)(undefined);
  const [favoriteListId, setFavoriteListId] = (0, _react.useState)(undefined);
  const [gamificationActivityType, setGamificationActivityType] = (0, _react.useState)(undefined);
  const onOpen = (0, _react.useCallback)(({
    detail
  }) => {
    setType(detail.type);
    onOpenParam();
    setProductCode(detail.productCode);
    setCataloguePageNumber(detail.cataloguePageNumber);
    setCatalogueId(detail.catalogueId);
    setFavoriteListId(detail.favoriteListId);
    setGamificationActivityType(detail.gamificationActivityType);
  }, [onOpenParam]);
  const onClose = (0, _react.useCallback)(() => {
    onCloseParam();
    setTimeout(() => setProductCode(undefined), 200);
  }, [onCloseParam]);
  const events = (0, _react.useMemo)(() => [{
    name: _openFeedbackBenefitDialog.Name,
    listener: onOpen
  }], [onOpen]);
  (0, _presentationHooks.useGlobalEvents)(events);
  (0, _react.useEffect)(() => {
    const shareParameter = (0, _presentationUtils.getClientQueryParam)(_constants.SHARE_OPEN_PARAM);
    if (shareParameter) {
      window.dispatchEvent(new CustomEvent(_openFeedbackBenefitDialog.Name, {
        detail: {
          type: _net.FeedbackBenefitBannerType.ShareAndEarn
        }
      }));
      // remove the share parameter from the url
      const url = new URL(window.location.href);
      url.searchParams.delete(_constants.SHARE_OPEN_PARAM);
      window.history.replaceState({}, '', url.toString());
    }
  }, []);
  const value = (0, _react.useMemo)(() => ({
    cataloguePageNumber,
    catalogueId,
    favoriteListId,
    gamificationActivityType,
    open,
    productCode,
    type,
    onClose
  }), [cataloguePageNumber, catalogueId, favoriteListId, gamificationActivityType, open, productCode, type, onClose]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Provider, {
    value: value,
    children: children
  });
};
exports.FeedbackBenefitDialogProvider = FeedbackBenefitDialogProvider;
const useFeedbackBenefitDialog = () => (0, _react.useContext)(feedbackBenefitDialogContext);
exports.useFeedbackBenefitDialog = useFeedbackBenefitDialog;
